import { Fragment } from '@tiptap/pm/model';

/**
 * Counts the number of "lines" in a fragment.
 *
 * A line is any leaf block (e.g. a paragraph, heading, horizontal rule or image).
 * This descends into container nodes such as lists and list items so that adding/removing a list item
 * is detected as a line count change.
 */
export const getLineCount = (fragment: Fragment): number => {
    let count = 0;

    fragment.forEach((node) => {
        const nodeLineCount =
            node.childCount && !node.isTextblock
                ? // Descend into container nodes (lists, list items, blockquotes, ...) but stop at text blocks
                  getLineCount(node.content)
                : 1;
        count += nodeLineCount;
    });

    return count;
};
